<mat-form-field class="chip-list" appearance="fill">
  <mat-label>Has Read</mat-label>
  <mat-select [value]="hasRead()" multiple (valueChange)="onHasReadChange($event)" >
    <mat-select-trigger>
      <mat-chip-listbox>
        @for(hasReadUser of hasRead(); track hasReadUser) {
        <mat-chip >
          {{ hasReadUser }}
        </mat-chip>
        }
      </mat-chip-listbox>
    </mat-select-trigger>
    @for (name of allUsers; track name ) {
    <mat-option [value]="name">
      {{ name }}
    </mat-option>
    }
  </mat-select>
</mat-form-field>